export default __webpack_public_path__ + "static/media/green_5.aa81374b.png";